import {Component, Directive, EventEmitter, HostListener, Input, Output} from "@angular/core";
/**
 * Created by shahar on 09-May-17.
 */

@Component({
	selector:'cp-window-detector',
	template:'<div><div *ngIf="detecMouseUp" (mouseUpDetected)="mouseUpDetected.emit($event);" cpDetectWindowMouseUp></div>' +
	'<div *ngIf="detecMouseMove" (moveDetected)="moveDetected.emit($event);"  cpDetectWindowMouseMove></div>' +
	'<div *ngIf="detectContextMenu" (contextMenuDetected)="contextMenuDetected.emit($event);"  cpDetectWindowContextMenu></div>' +
	'</div>'
})
export class WindowEventsDetector{
	@Input() detecMouseUp:boolean;
	@Input() detecMouseMove:boolean;
	@Input() detectContextMenu:boolean;

	@Output() moveDetected= new EventEmitter();
	@Output() mouseUpDetected= new EventEmitter();
	@Output() contextMenuDetected= new EventEmitter();
}


@Directive({
	selector:'[cpDetectWindowContextMenu]'
})
export class ContextMenuDetectDirective{
	@Output() contextMenuDetected= new EventEmitter();

	@HostListener('window:contextmenu', ['$event'])
	public onConextMenu(event) {
		this.contextMenuDetected.emit(event);
	}
}

@Directive({
	selector:'[cpDetectWindowMouseUp]'
})
export class MouseUpDetectDirective{
	@Output() mouseUpDetected= new EventEmitter();

	@HostListener('window:mouseup', ['$event'])
	public onMouseUp(event) {
		this.mouseUpDetected.emit(event);
	}
}

@Directive({
	selector:'[cpDetectWindowMouseMove]'
})
export class MouseMoveDetectDirective{
	@Output() moveDetected= new EventEmitter();

	@HostListener('window:mousemove', ['$event'])
	public onResizeMouseMove(event) {
		this.moveDetected.emit(event);
	}
}
